import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform, NgZone } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { NewPurchaseReturnService, CommonService, SubscribeService, BranchService } from '../../../services/index';
import { NewPurchaseReturnModel } from '../../../model/index';

@Component({
    selector: 'addEditNewPurchaseReturn-tab',
    templateUrl: './addEditNewPurchaseReturn.component.html',
})
export class AddEditNewPurchaseReturnComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];

    isLoadMask: Promise<any>;
    isLoading: boolean = false;
    minDate: any;

    @Input() purchaseReturngriddata: NewPurchaseReturnModel[] = [];
    @Input() newPurchaseReturn: NewPurchaseReturnModel[] = [];

    partyCtrl: FormControl;
    serialNoCtrl: FormControl;
    modelCtrl: FormControl;
    typeCtrl: FormControl;
    modelTypeCtrl: FormControl;
    halistCtrl: FormControl;

    filteredParty: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    filteredModel: Observable<any[]>;
    filteredType: Observable<any[]>;
    filteredHa: Observable<any[]>;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('amountTemplate') amountTemplate: TemplateRef<any>;

    partyList: any[] = [];
    serialNoList: any[] = [];
    modelList: any[] = [];
    typeList: any[] = [];
    ModelList: any[] = [];
    actModelList: any[] = [];
    modelTypeList: string[] = ['HA MODEL', 'Spare'];
    haList: any[] = [];
    actSerialNoList: any[] = [];

    newPurchaseReturnData: any = {
        return_id: '',
        auto_no: '',
        date: new Date(),
        party_id: '',
        party_name: '',
        grand_total: 0,
        gross_total: 0,
        discount_percentage: 0,
        discount_amount: 0,
        round_off: 0,
        description: '',
        tot_qty: 0,
        is_reset_data: false,
        mode: 'Add',
        btnTxt: 'Save'
    };

    newPurchaseReturnGridData: any = {
        model_type: '',
        model_id: '',
        model_name: '',
        serial_no: '',
        brand_name: '',
        brand_model_name: '',
        family_name: '',
        series_name: '',
        performance_name: '',
        power_name: '',
        battery_name: '',
        tele_audiology: '',
        mrp_value: 0,
        act_qty: 1
    };

    selectedBranchCtrl: FormControl;
    selectedHVUserCtrl: FormControl;

    filteredBranch: Observable<any[]>;
    filteredHVUser: Observable<any[]>;

    columns = [];
    toggleCol = [];
    newPurchaseReturnDetails: any[] = [];
    reorderable: boolean = true;
    loadingIndicator: boolean = false;
    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'model_id',
        orderDir: 'asc'
    };

    constructor(private newPurchaseReturnService: NewPurchaseReturnService,
        public subscribeService: SubscribeService,
        private modalService: BsModalService,
        public snackBar: MdSnackBar,
        private comstore: Store<fromCommonStore.State>,
        public commonService: CommonService,
        public branchService: BranchService,
        public toasterService: ToasterService,
        private ngZone: NgZone) {

        // PARTY validation function
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            hasValidParty.bind(this)
        ]);

        // MODEL TYPE validation function
        function hasValidModelType(input: FormControl) {
            if (this.modelTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidModelType: true };
        }
        this.modelTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidModelType.bind(this)
        ]);

        // HA MODEL validation function
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        // Initialize other form controls
        this.serialNoCtrl = new FormControl();
        this.modelCtrl = new FormControl();
        this.typeCtrl = new FormControl();

        // Setup filterable observables
        this.filteredParty = this.partyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterParty(name) : this.partyList.slice());

        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());

        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

        this.filteredType = this.typeCtrl.valueChanges
            .startWith(null)
            .map(name => this.filterType(name));

    }

    ngOnInit(): void {
        this.minDate = new Date();
        this.setupGridColumns();
        this.loadInitialData();
        this.page.count = this.newPurchaseReturnDetails.length;
    }

    setupGridColumns(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Model', prop: 'model_name', width: 220, minWidth: 220, maxWidth: 220, toggle: true },
            { name: 'Serial No', prop: 'serial_no', width: 140, minWidth: 140, maxWidth: 140, toggle: true },
            { name: 'Brand', prop: 'brand_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'MRP', prop: 'mrp_value', width: 80, minWidth: 80, maxWidth: 80, toggle: true },
            { name: 'Qty', prop: 'act_qty', width: 90, minWidth: 90, maxWidth: 90, toggle: true, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
    }

    loadInitialData(): void {
        // Load dropdown data
        this.loadPartyList();
        this.loadTypeList();

        // Load auto number for new entries
        if (this.mode === 'Add' || !this.mode) {
            this.newPurchaseReturnData['mode'] = 'Add';
            this.newPurchaseReturnData['btnTxt'] = 'Save';
            this.loadAutoNumber();
        }
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: this.newPurchaseReturnData['tabParams'] || 'Purchase Return',
                date: moment(this.newPurchaseReturnData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.newPurchaseReturnData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadPartyList(): void {
        let that = this;
        this.commonService
            .getPartyList()
            .then(function (res: any) {
                if (res.success) {
                    that.partyList = res.data;
                    that.partyCtrl.setValue(that.newPurchaseReturnData['party_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Failed to load party list'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadTypeList(): void {
        this.typeList = ['HA Model', 'Spare'];
    }



    // Filter functions
    filterParty(name: string): any[] {
        name = _.escapeRegExp(name);
        return this.partyList.filter(party => (new RegExp(name, 'gi').test(party.party_name)));
    }

    filterSerialNo(val: string): any[] {
        val = _.escapeRegExp(val);
        return this.serialNoList.filter(s => (new RegExp(val, 'gi').test(s.serial_no)));
    }

    filterModel(name: string): any[] {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.model_id)
            || new RegExp(name, 'gi').test(item.name)));
    }

    filterType(val: string): any[] {
        return val ? this.typeList.filter(s => s.name.toLowerCase().indexOf(val.toLowerCase()) === 0)
            : this.typeList;
    }


    // Transfer Challan Out Style Methods
    displayModelTypeFn(modelType: any): string {
        if (this.modelTypeList != undefined && this.modelTypeList.length > 0 && modelType) {
            this.loadChallanHaList(modelType);
            return this.modelTypeList.indexOf(modelType) >= 0 ? modelType : '';
        }
        return '';
    }

    loadChallanHaList(model_type: string): void {
        let that = this,
            data = {
                stock_type: model_type,
                from_page: 'NPR',
                load_all_branches: true  // Load from all branches for purchase return
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                const uniqueArray = res['haStockModel'].filter((value, index, self) =>
                            index === self.findIndex((t) => (
                              t.model_id === value.model_id
                            ))
                        );
                that.haList = uniqueArray;
                that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue('');
                that.serialNoCtrl.setValue('');
            });
    }

    filterHa(name: string): any[] {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    displayHa(item_id: number): string {
        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': item_id });
            this.newPurchaseReturnGridData['model_name'] = fhalist['name'];
            this.newPurchaseReturnGridData['brand_name'] = fhalist['brand_name'];
            this.newPurchaseReturnGridData['brand_model_name'] = fhalist['brand_model_name'];
            this.newPurchaseReturnGridData['family_name'] = fhalist['family_name'];
            this.newPurchaseReturnGridData['series_name'] = fhalist['series_name'];
            this.newPurchaseReturnGridData['performance_name'] = fhalist['performance_name'];
            this.newPurchaseReturnGridData['power_name'] = fhalist['power_name'];
            this.newPurchaseReturnGridData['battery_name'] = fhalist['battery_name'];
            this.newPurchaseReturnGridData['color_name'] = fhalist['color_name'];
            this.newPurchaseReturnGridData['color_id'] = fhalist['color_id'];
            this.newPurchaseReturnGridData['tele_audiology'] = fhalist['tele_audiology'];
            this.newPurchaseReturnGridData['mrp_value'] = fhalist['mrp'];
            this.getModelSerialNo(item_id);
            return fhalist['name'];
        }
        return '';
    }

    getModelSerialNo(modelID: number): void {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, (s) => String(s.model_id) === String(modelID));
        this.serialNoCtrl.setValue(this.newPurchaseReturnGridData['serial_no']);
    }

    displaySerialNo(serial_no: string): string {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, (s) => String(s.serial_no) === String(serial_no));
            if (fhalist && fhalist.model_id) {
                this.newPurchaseReturnGridData['model_id'] = fhalist.model_id;
                this.newPurchaseReturnGridData['serial_no'] = fhalist.serial_no;
                this.newPurchaseReturnGridData['mrp_value'] = fhalist.mrp;
                return fhalist['serial_no'];
            }
        }
        return serial_no || '';
    }

    onSerialNoOptionSelected(event: any): void {
        let selectedSerialNo = event.option.value;
        let fhalist = _.find(this.serialNoList, (s) => String(s.serial_no) === String(selectedSerialNo));
        if (fhalist) {
            this.newPurchaseReturnGridData['serial_no'] = fhalist.serial_no;
            this.newPurchaseReturnGridData['model_id'] = fhalist.model_id;
            this.newPurchaseReturnGridData['mrp_value'] = fhalist.mrp;
        }
    }


    // Serial Number selection - auto load model
    onSerialNoSelect(selectedSerialNo: any): void {
        if (selectedSerialNo && selectedSerialNo.model_id) {
            // Auto-populate model field
            this.modelCtrl.setValue(selectedSerialNo.model_id);

            // Load model details
            let params = {
                serial_no: selectedSerialNo.serial_no,
                model_id: selectedSerialNo.model_id
            };

            this.newPurchaseReturnService.getModelDetails(params).then((res: any) => {
                if (res.success && res.data) {
                    // Auto-fill other fields based on serial number
                    this.typeCtrl.setValue(res.data.stock_type || '');
                }
            });
        }
    }

    // Load available serial numbers based on selected type and model
    loadSerialNumbers(): void {
        let typeValue = this.typeCtrl.value;
        let modelValue = this.modelCtrl.value;

        if (typeValue) {
            let params = {
                stock_type: typeValue,
                model_id: modelValue || ''
            };

            this.newPurchaseReturnService.getAvailableSerialNumbers(params).then((res: any) => {
                this.serialNoList = res.data || [];
            });
        }
    }

    addToGrid(): void {
        let modelID = this.newPurchaseReturnGridData['model_id'];
        let modelName = this.newPurchaseReturnGridData['model_name'] || '';
        let serialNo = String(this.newPurchaseReturnGridData['serial_no'] || '');
        let modelType = this.newPurchaseReturnGridData['model_type'];
        let qty = this.newPurchaseReturnGridData['act_qty'];

        if (!modelID) {
            swal('Warning', 'Please select Model', 'warning');
            return;
        }

        if (qty == null || qty == "" || qty == 0) {
            swal('ERROR', 'Please Enter The Qty', 'error');
            return;
        }

        // Check if item already exists in grid
        let preTestID = _.find(this.newPurchaseReturnDetails, { 'model_id': modelID, 'serial_no': serialNo });
        if (preTestID) {
            swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
            return;
        }

        // Check serial number exists in that model
        let actSerialNoList = this.actSerialNoList;
        let currSerialNoObj = _.find(actSerialNoList, (item) => {
            return String(item.model_id) === String(modelID) && String(item.serial_no) === String(serialNo);
        });
        if (!currSerialNoObj) {
            swal('WARNING', 'Serial No : ' + serialNo + ' Does Not Exists in This Model');
            return;
        }

        // Validate required fields for HA MODEL
        if (modelType == 'HA MODEL' && (serialNo === '' || serialNo === null || serialNo === undefined)) {
            swal('Warning', 'Enter Serial No', 'warning');
            return;
        }

        // Add to grid
        let testDet = Object.assign({}, this.newPurchaseReturnGridData);
        this.newPurchaseReturnDetails.push(testDet);

        // Expand functionality - same as Transfer Challan Out
        if (this.newPurchaseReturnData['is_reset_data']) {
            this.newPurchaseReturnGridData['serial_no'] = "";
        } else {
            this.clearItemFields();
        }

        this.page.count = this.newPurchaseReturnDetails.length;
        this.calculateTotals();
    }

    deleteFromGrid(row: any): void {
        if (this.mode == 'View') {
            return;
        }
        this.newPurchaseReturnDetails.splice(this.newPurchaseReturnDetails.indexOf(row), 1);
        this.newPurchaseReturnDetails = this.newPurchaseReturnDetails.slice();
        this.page.count = this.newPurchaseReturnDetails.length;
        this.calculateTotals();
    }

    calculateTotals(): void {
        let totalQty = 0;
        let grossTotal = 0;

        this.newPurchaseReturnDetails.forEach(item => {
            totalQty += parseFloat(item.quantity || 0);
            grossTotal += parseFloat(item.total_amount || 0);
        });

        let discountAmount = (grossTotal * parseFloat(String(this.newPurchaseReturnData.discount_percentage || '0'))) / 100;
        let grandTotal = grossTotal - discountAmount + parseFloat(String(this.newPurchaseReturnData.round_off || '0'));

        this.newPurchaseReturnData.tot_qty = totalQty;
        this.newPurchaseReturnData.gross_total = grossTotal;
        this.newPurchaseReturnData.discount_amount = discountAmount;
        this.newPurchaseReturnData.grand_total = grandTotal;
    }

    clearItemFields(): void {
        this.newPurchaseReturnGridData = {
            model_type: '',
            model_id: '',
            model_name: '',
            serial_no: '',
            brand_name: '',
            brand_model_name: '',
            family_name: '',
            series_name: '',
            performance_name: '',
            power_name: '',
            battery_name: '',
            color_name: '',
            color_id: '',
            tele_audiology: '',
            mrp_value: 0,
                act_qty: 1
        };
        this.halistCtrl.setValue('');
        this.serialNoCtrl.setValue('');
        this.modelTypeCtrl.setValue('');
    }

    // Form validation method
    hasInvalidForm(): boolean {
        return (this.partyCtrl.errors && (this.partyCtrl.errors['inValidParty'] || this.partyCtrl.errors['required']));
    }

    saveNewPurchaseReturn(): void {
        if (this.newPurchaseReturnDetails.length === 0) {
            swal('ERROR', 'Please Enter Atleast One Details', 'error');
            return;
        }

        let returnFormDet = JSON.stringify(this.newPurchaseReturnDetails);
        let returnDate = moment(this.newPurchaseReturnData['date']).format('YYYY-MM-DD');

        if (this.newPurchaseReturnData['btnTxt'] == 'Save') {
            let params = {
                auto_no: this.newPurchaseReturnData['auto_no'],
                party_id: this.newPurchaseReturnData['party_id'],
                party_name: this.newPurchaseReturnData['party_name'],
                description: this.newPurchaseReturnData['description'] ? this.newPurchaseReturnData['description'] : '',
                return_date: returnDate,
                particulars: returnFormDet,
                mode: 'Add'
            };

            this.isLoading = true;
            this.newPurchaseReturnService.addUpdateNewPurchaseReturnEntry(params).then((res: any) => {
                this.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success').then(() => {
                        this.subscribeService.subScribeDeleteActiveTab();
                        this.subscribeService.subReloadNewPurchaseReturnListGrid();
                    });
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        } else if (this.newPurchaseReturnData['btnTxt'] == 'Update') {
            let params = {
                return_id: this.newPurchaseReturnData['return_id'],
                auto_no: this.newPurchaseReturnData['auto_no'],
                party_id: this.newPurchaseReturnData['party_id'],
                party_name: this.newPurchaseReturnData['party_name'],
                description: this.newPurchaseReturnData['description'] ? this.newPurchaseReturnData['description'] : '',
                return_date: returnDate,
                particulars: returnFormDet,
                mode: 'Edit'
            };

            this.isLoading = true;
            this.newPurchaseReturnService.addUpdateNewPurchaseReturnEntry(params).then((res: any) => {
                this.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success').then(() => {
                        this.subscribeService.subScribeDeleteActiveTab();
                        this.subscribeService.subReloadNewPurchaseReturnListGrid();
                    });
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }
    }

    setPageData(): void {
        if (this._params && this._params['mode']) {
            this.mode = this._params['mode'];
            if ((this.mode === 'Edit' || this.mode === 'View') && this._params['return_id']) {
                this.loadPurchaseReturnForEdit(this._params['return_id']);
            }
        }
    }

    loadPurchaseReturnForEdit(returnId: string): void {
        let params = { return_id: returnId };
        this.newPurchaseReturnService.getNewPurchaseReturnDetails(params).then((res: any) => {
            if (res.success) {
                // Set header data
                this.newPurchaseReturnData = res.data.header;

                // Convert date format for datepicker
                if (this.newPurchaseReturnData.date_formatted) {
                    this.newPurchaseReturnData.date = new Date(this.newPurchaseReturnData.date_formatted);
                }

                // Set button text for edit mode
                this.newPurchaseReturnData.btnTxt = 'Update';
                this.newPurchaseReturnData.mode = 'Edit';

                // Update form controls
                this.partyCtrl.setValue(this.newPurchaseReturnData.party_id);

                // Set details data
                this.newPurchaseReturnDetails = res.data.details || [];
                this.page.count = this.newPurchaseReturnDetails.length;
                this.calculateTotals();
            }
        });
    }

    // Display functions for autocomplete
    displayPartyFn(partyID: number): string {
        if (partyID && this.partyList.length > 0) {
            let fitem = _.find(this.partyList, { 'party_id': partyID });
            if (fitem) {
                this.newPurchaseReturnData['party_name'] = fitem['party_name'];
                return fitem['party_name'];
            }
        }
        return '';
    }

    displaySerialNoFn(serialNo: any): string {
        return serialNo ? serialNo.serial_no : '';
    }

    displayModelFn(modelID: number): string {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            if (fitem) {
                this.newPurchaseReturnGridData['model_name'] = fitem['name'];
                this.newPurchaseReturnGridData['mrp_value'] = fitem['mrp'];
                this.newPurchaseReturnGridData['brand_name'] = fitem['brand_name'];
                this.newPurchaseReturnGridData['brand_model_name'] = fitem['brand_model_name'];
                this.newPurchaseReturnGridData['family_name'] = fitem['family_name'];
                this.newPurchaseReturnGridData['series_name'] = fitem['series_name'];
                this.newPurchaseReturnGridData['performance_name'] = fitem['performance_name'];
                this.newPurchaseReturnGridData['power_name'] = fitem['power_name'];
                this.newPurchaseReturnGridData['battery_name'] = fitem['battery_name'];
                this.newPurchaseReturnGridData['color_name'] = fitem['color_name'];
                this.newPurchaseReturnGridData['color_id'] = fitem['color_id'];
                this.newPurchaseReturnGridData['tele_audiology'] = fitem['tele_audiology'];
                return fitem['name'];
            }
        }
        return '';
    }

    displayTypeFn(type: any): string {
        return type ? type.name : '';
    }


}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/newPurchaseReturn/addEditNewPurchaseReturn.component.ts